import React from 'react';

import { MDText } from 'i18n-react';

import { GraphIcon, PriceTagIcon, VehicleFrontIcon } from '@motorway/mw-highway-code';

import LocalTexts from '../../CustomerHubTexts.json';

import styles from './TrackerUSP.scss';

const LocalT = new MDText(LocalTexts);

const TEXTS = [
  {
    icon: PriceTagIcon,
    text: LocalT.translate('usp.p1'),
    title: LocalT.translate('usp.title1'),
  },
  {
    icon: GraphIcon,
    text: LocalT.translate('usp.p2'),
    title: LocalT.translate('usp.title2'),
  },
  {
    icon: VehicleFrontIcon,
    text: LocalT.translate('usp.p3'),
    title: LocalT.translate('usp.title3'),
  },
];

const TrackerUSP = () => (
  <ul className={styles.component}>
    {
      TEXTS.map(({ icon: Icon, ...item }, index) => (
        <li key={`tracker-usp-${index}`} className={styles.listItem}>
          <div className={styles.wrapper}>
            <Icon size="medium" />
            <h4 className={styles.title}>{item.title}</h4>
          </div>
          <p className={styles.text}>{item.text}</p>
        </li>
      ))
    }
  </ul>
);

export default TrackerUSP;
